export default __webpack_public_path__ + "static/bg-clocks-b8926c1928a7f4f39814a37cd34c2ee2.jpg";